'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _reactRouterRedux = require('react-router-redux');

var _actionsTypeConsts = require('./actionsTypeConsts.js');

var _actionsTypeConsts2 = _interopRequireDefault(_actionsTypeConsts);

var _chooseProviderSaga = require('./chooseProviderSaga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initSagas(storeApi, providerApi) {
  var _marked = /*#__PURE__*/_regenerator2.default.mark(learnMore),
      _marked2 = /*#__PURE__*/_regenerator2.default.mark(compareProviders);

  function learnMore(action) {
    var provider;
    return _regenerator2.default.wrap(function learnMore$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            provider = action.payload;
            _context.next = 3;
            return (0, _effects.put)((0, _reactRouterRedux.push)('/learnmore/' + provider.appDefId));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _marked, this);
  }

  function compareProviders() {
    return _regenerator2.default.wrap(function compareProviders$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _effects.put)((0, _reactRouterRedux.push)('/compareProviders'));

          case 2:
          case 'end':
            return _context2.stop();
        }
      }
    }, _marked2, this);
  }

  // eslint-disable-next-line func-names
  return (/*#__PURE__*/_regenerator2.default.mark(function configurationSagas() {
      return _regenerator2.default.wrap(function configurationSagas$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return [(0, _reduxSaga.takeEvery)(_actionsTypeConsts2.default.learnMore, learnMore), (0, _reduxSaga.takeEvery)(_actionsTypeConsts2.default.chooseProvider, (0, _chooseProviderSaga.createChooseProviderSaga)(storeApi, providerApi)), (0, _reduxSaga.takeEvery)(_actionsTypeConsts2.default.compareProviders, compareProviders)];

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, configurationSagas, this);
    })
  );
}
exports.default = initSagas;